import { OWObject } from "../../../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { IMasterableFrame } from "../../Frames/FrameInterfaces";
import { IFrame } from "../../IFrame";
import { XGAction } from "../XGAction";
import { IActionExecutionContext } from "./IActionExecutionContext";

export class ActionLocalExecutionContext implements IActionExecutionContext {
    private _action: XGAction;

    constructor(action: XGAction) {
        this._action = action;
    }

    public get actualObject(): OWObject | null {
        if (!this._action.owner) {
            return null;
        }
        //po dotazu na uložení není včas na detailu aktuální instance, proto je potřeba brát objekt ze seznamu, kde je veškerá funkčnost nad objekty
        if (!(this._action.owner instanceof IMasterableFrame) && this._action.owner.masterFrame != null) {
            return this._action.owner.masterFrame.actualObject;
        }
        return this._action.owner.actualObject;
    }

    public get ownerFrame(): IFrame | null {
        return this._action.owner;
    }
}
